import { trpc } from "@/lib/trpc";

export const useValidateInvitationQuery = (token: string) =>
    trpc.invitations.validate.useQuery(
        { token },
        { enabled: !!token, retry: false }
    );

export const useInvitationsQuery = () => trpc.invitations.findMany.useQuery();

export const usePendingInvitationsQuery = () => trpc.invitations.findPending.useQuery();

